export const expression = /,/g;

export default (value: string): string => value.replace(expression, '.');
